
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { CertificationsModel } from 'src/app/models/certifications.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { ToastService } from 'src/app/services/toast.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { CertificationModalComponent } from './certification-modal/certification-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-certifications',
    imports: [IconMenuButtonComponent, MatMenuModule, MatButtonModule, MatIconModule, PageHeaderComponent, EmptyStateComponent],
    templateUrl: './certifications.component.html',
    styleUrls: ['./certifications.component.scss']
})
export class CertificationsComponent {
  private readonly certificationSvc = inject(SupplierService);
  toastr = inject(ToastService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);

  dialog = inject(MatDialog);

  certifications: CertificationsModel[] = [];
  selectedCertificateToEdit?: CertificationsModel;

  ngOnInit() {
    this.getCertifications();
  }

  getCertifications() {
    this.certificationSvc.getAllCertifications().subscribe({
      next: (data) => {
        this.certifications = data;
      },
    });
  }

  dialogAction(certificate?: CertificationsModel) {
    let currentDialog = this.dialog.open(CertificationModalComponent, {
      width: '560px',
      maxWidth: '95vw',
      maxHeight: '95vh',
      data: certificate,
    });

    currentDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => this.ngOnInit());
  }

  deleteCertification(id: string) {
    this.swalFire
      .SwalFireQuestion(
        'Eliminar certificación',
        '¿Está seguro que desea eliminar la certificación?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.certificationSvc.deleteCertification(id, false).subscribe({
            next: (result) => {
              this.toastr.success(
                'Certificación eliminada',
                'La certificación se ha eliminado correctamente.'
              );
              this.getCertifications();
            },
            error: (err) => {
              this.toastr.error(
                'Error',
                'No se pudo eliminar la certificación.'
              );
            },
          });
        }
      });
  }
}
